import { jsx } from "react/jsx-runtime";
import { cn } from "@tameeni/shared-logic";
import { useState, useEffect, useMemo, Suspense } from "react";
import { a as allIcons, I as ImageKeys } from "./icons-other-DjbidUg5.js";
function LazyImage({
  className,
  src,
  ...props
}) {
  const [image, setImage] = useState("");
  useEffect(() => {
    if (src instanceof Promise) {
      src.then((data) => setImage(data.default)).catch((e) => console.log({ e }));
    }
  }, [src]);
  return image ? /* @__PURE__ */ jsx(
    "img",
    {
      src: image,
      className: cn("object-scale-down size-6", className),
      ...props,
      alt: props.alt || ""
    }
  ) : /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("animate-pulse rounded bg-slate-200/50 size-6", className)
    }
  );
}
function Icon({ name, className, ...props }) {
  const IconComponent = useMemo(
    () => allIcons[name],
    [name]
  );
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }
  const fallbackContent = /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "animate-pulse rounded bg-slate-200/50 size-4.5",
        className
      )
    }
  );
  if (ImageKeys.includes(name)) {
    return /* @__PURE__ */ jsx(
      LazyImage,
      {
        src: allIcons[name],
        className: cn("shrink-0 size-4.5", className),
        alt: name
      }
    );
  }
  return /* @__PURE__ */ jsx(Suspense, { fallback: fallbackContent, children: /* @__PURE__ */ jsx(
    IconComponent,
    {
      className: cn("shrink-0 size-4.5", className),
      ...props
    }
  ) });
}
export {
  Icon as I
};
